
    import { computed, defineComponent, type PropType } from 'vue'

    import DiscordIcon from '@/app/components/sidebar/player/DiscordIcon.vue'

    import type { Song } from '@/common/models/data/dashboard/song'
    import { useSharedSettingsStore } from '@/common/stores/shared-settings'

    export default defineComponent({
        components: {
            DiscordIcon
        },
        props: {
            appDiscovered: {
                type: Boolean,
                required: true
            },
            buffering: {
                type: Boolean,
                required: true
            },
            cover: {
                type: String,
                default: ''
            },
            coverAlt: {
                type: String,
                default: ''
            },
            playing: {
                type: Boolean,
                required: true
            },
            song: {
                type: Object as PropType<Song>,
                required: true
            }
        },
        emits: [
            'app-discovered',
            'toggle'
        ],
        setup () {
            const settingsStore = useSharedSettingsStore()
            const historyUrl = computed(() => settingsStore.setting('player-history'))
            const playStoreUrl = computed(() => settingsStore.setting('player-android'))
            const discordBotUrl = computed(() => settingsStore.setting('discord-bot-invite-url'))

            const showDiscordButton = computed((): boolean => {
                return discordBotUrl.value !== ''
            })

            return {
                discordBotUrl,
                historyUrl,
                playStoreUrl,
                showDiscordButton
            }
        }
    })
